import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { APP_NAME } from '../../../config/branding';
import { BrandMark } from '../../../components/ui/BrandMark';
import { colors, spacing, typography } from '../../../core/theme/tokens';

type AuthBrandHeaderProps = {
  headline: string;
  subtitle: string;
};

export function AuthBrandHeader({ headline, subtitle }: AuthBrandHeaderProps) {
  return (
    <View style={styles.wrap}>
      <View style={styles.markRow}>
        <BrandMark size={36} />
        <Text style={styles.brand}>{APP_NAME}</Text>
      </View>
      <Text style={styles.headline}>{headline}</Text>
      <Text style={styles.subtitle}>{subtitle}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    gap: spacing.sm,
    alignItems: 'center',
    marginBottom: spacing.md,
  },
  markRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    marginBottom: spacing.sm,
  },
  brand: {
    fontSize: 22,
    fontWeight: '700',
    letterSpacing: 0.6,
    color: colors.text,
  },
  headline: {
    ...typography.title,
    color: colors.text,
    fontSize: 26,
    textAlign: 'center',
  },
  subtitle: {
    ...typography.body,
    color: colors.textMuted,
    lineHeight: 22,
    textAlign: 'center',
    maxWidth: 320,
  },
});
